import Cadastro from '@/pages/entradaMercadoria/Cadastro'
import Listar from '@/pages/entradaMercadoria/Listar'

export const entradaMercadoriaRoutes = [
    {
        path: '/entrada-mercadoria',
        name: 'entradaMercadoria',
        component: Listar
    },
    {
        path: '/entrada-mercadoria/cadastro',
        name: 'entradaMercadoriaCadastro',
        component: Cadastro
    },
    {
        path: '/entrada-mercadoria/:id/editar',
        name: 'entradaMercadoriaEditar',
        component: Cadastro,
        props: true
    }
]

export default {}
